import { useModals } from 'almanac-ui/Modal'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { FacebookNotice } from 'components/IntegrationInitialization/FacebookInitialization/FacebookInitialization'
import { IntegrationInitializationDrawer } from 'components/IntegrationInitialization/IntegrationInitializationDrawer'
import { InitializationDrawer } from 'components/Onboarding/CreateBrandStyleModal/InitializationDrawer'
import { ConnectProps, useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useRootStore } from 'stores/RootStore'
import { Facebook } from 'blaze-ui/icons'
import { IntegrationInitializationModal } from 'components/IntegrationInitialization/IntegrationInitializationModal'

interface Props extends ConnectProps {
  isSingleSelect?: boolean
  allowReconnect?: boolean
}

export const useConnectFacebook = ({ onConnect, isSingleSelect, allowReconnect, onIntegrationAuthCreated }: Props) => {
  const { openModal, closeStack } = useModals()
  const { connect } = useConnectAccountPopup({ isSingleSelect, allowReconnect })
  const { initiateOauth } = useInitiateOauth()
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()
  const { openDrawer, closeDrawer } = drawersStore

  const handleConfirm = async () => {
    const popup = await initiateOauth(
      ExternalIntegrationEnum.Facebook,
      undefined,
      '_blank',
      'popup=true,width=600,height=780',
    )
    popup && connect(popup, { onConnect, onIntegrationAuthCreated })
  }

  const commonProps = {
    providerName: 'Facebook (Meta)',
    icon: <Facebook size={32} />,
    title: 'Connect your account',
    primaryButtonText: 'Go to Facebook Business',
    notice: <FacebookNotice />,
  }

  return () => {
    if (isMobile) {
      openDrawer(InitializationDrawer, {
        component: () => (
          <IntegrationInitializationDrawer
            {...commonProps}
            onConfirm={() => {
              handleConfirm()
              closeDrawer()
            }}
          />
        ),
      })
      return
    }

    openModal(
      IntegrationInitializationModal,
      {
        ...commonProps,
        onConfirm: () => {
          handleConfirm()
          closeStack()
        },
        onClose: () => {
          closeStack()
        },
        onPressOutside: () => {
          closeStack()
        },
      },
      { newStack: true },
    )
  }
}
